import React, { useContext, useEffect, useState } from 'react';
import ButtonBack from './images/x.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell as farBell } from '@fortawesome/free-solid-svg-icons';
import { faVolumeUp as fasVolume, faMusic as fasMusic } from '@fortawesome/free-solid-svg-icons';
import { faMobileAlt as farMobile } from '@fortawesome/free-solid-svg-icons';
import AudioContext from './AudioContext';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import { toast } from 'react-hot-toast';

function Settings({ onClose, isConnected, changeActiveComponent }) {
  const { volume, setVolume } = useContext(AudioContext);
  const { volumefx, setVolumefx } = useContext(AudioContext);
  const [vibration, setVibration] = useState(false);
  const [pushAlarm, setPushAlarm] = useState(false);

  const handleConnect = async () => {
    try {
      // The WalletMultiButton will handle wallet selection and connection
      // Your connect logic here (if any additional steps are needed)
    } catch (error) {
      console.error('Failed to connect wallet:', error);
    }
  };

  const handleVolumeChange = (e) => {
    setVolume(e.target.value / 100);
  };

  const handleVolumefxChange = (e) => {
    setVolumefx(e.target.value / 100);
  };

  const getSliderBackground = () => {
    const leftColor = '#fff';
    const rightColor = '#0000008e';
    const value = volume * 100;

    return `linear-gradient(to right, ${leftColor} ${value}%, ${rightColor} ${value}%)`;
  };

  const getSliderBackground2 = () => {
    const leftColor = '#fff';
    const rightColor = '#0000008e';
    const value = volumefx * 100;

    return `linear-gradient(to right, ${leftColor} ${value}%, ${rightColor} ${value}%)`;
  };

  const { disconnect } = useSolanaWeb3();

  useEffect(() => {
    if (!isConnected) {
      onClose(); // Close the settings when the wallet disconnects
    }
  }, [isConnected, onClose]);

  const handleReferralClick = () => {
    onClose(); // Call the onClose function
    changeActiveComponent('referral'); // Change the active component to 'referral'
  };
  const handleClaimClick = () => {
    toast.error("You don't have nothing to be claimed right now", {
    });
  };

  return (
    <div className="popup-container">
      <div className="popup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} />
        </button>
        <div className="settings-container">
        <h2>SETTINGS</h2>
        <div className="active-item-stats-top" id="setting-a"><div className="line5"></div><p>SOUND EFFECT</p><div className="line5"></div></div>
         <div className="settings-container-1">
            {/* <div className="audio-settings"><FontAwesomeIcon icon={farBell} /><p>Push Alarm</p>
            <div className={`slider-onoff ${pushAlarm ? 'on' : 'off'}`} onClick={() => setPushAlarm(!pushAlarm)}>
              <button></button>
              </div></div> */}
            <div className="audio-settings">
              <FontAwesomeIcon icon={fasVolume} /><p>Sound FX</p>
              <div className="slider-volumefx"><input
                type="range"
                min="0"
                max="100"
                value={volumefx * 100}
                onChange={handleVolumefxChange}
                style={{ background: getSliderBackground2() }}
              /></div></div> 
            <div className="audio-settings"><FontAwesomeIcon icon={fasMusic} /><p>Music</p>
              <div className="slider-volume"><input
                type="range"
                min="0"
                max="100"
                value={volume * 100}
                onChange={handleVolumeChange}
                style={{ background: getSliderBackground() }}
              /></div></div>
            {/*<div className="audio-settings"><FontAwesomeIcon icon={farMobile} /><p>Vibration</p>
            <div className={`slider-onoff ${vibration ? 'on' : 'off'}`} onClick={() => setVibration(!vibration)}><button></button></div></div>*/}
          </div>
          <div className="active-item-stats-top" id="setting-a"><div className="line4"></div><p>LINKS</p><div className="line4"></div></div>
          <div className="settings-container-2">
          <a href="https://discord.gg/Ccx3xT6ea3" className="setting-button" target="_blank"><span>DISCORD</span></a>
            <a href="https://t.me/kingdomofants" className="setting-button" target="_blank"><span>TELEGRAM</span></a>
            <a href="http://www.twitter.com/kingdomofANTS" className="setting-button" target="_blank" ><span>X (TWITTER)</span></a>
            <a href="https://gitbook.kingdomofants.io/kingdom-of-ants/platform" className="setting-button" target="_blank"><span>GITBOOK</span></a>
          </div>
          <div className="active-item-stats-top" id="setting-a"><div className="line3"></div><p>REFERRAL</p><div className="line3"></div></div>
          <div className="settings-container-3">
          <a className="setting-button" onClick={handleReferralClick}><span>REFERRAL</span></a>
          </div>
          <div className="active-item-stats-top" id="setting-a"><div className="line3"></div><p>ACCOUNT</p><div className="line3"></div></div>
          <div className="settings-container-4">
          <a className="setting-button" id="right1" onClick={handleClaimClick}><span>CLAIM</span></a>
          <a className="setting-button" id="right2" onClick={disconnect}><span>DISCONNECT</span></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;